import Blue from '~/core';

new Blue({
  name: 'Header Nav Menu',
  selector: '.header',
  setup(header) {
    const nav = header.querySelector('.header__nav');
    const navItems = [...nav.querySelectorAll('.nav__primary > .nav__item')];
    const navToggles = [...nav.querySelectorAll('.nav__toggle.has-mega')];
    const navMenus = [...nav.querySelectorAll('.nav__mega')];
    const search = header.querySelector('.search');
    const searchToggle = header.querySelector('.search__toggle');
    const toggleEvents = 'click enter space';
    const toggleSearch = () => {
      search.classList.toggle('is-active');
    };

    this.$addEvents(searchToggle, toggleEvents, toggleSearch);

    const closeMenus = (exception = false) => {
      const openItems = [...header.querySelectorAll('.is-active')].filter(
        i => i !== exception
      );
      openItems.forEach(i => i.classList.remove('is-active'));
    };

    const toggleMenu = item => {
      let focus = item.querySelector('a, input');
      item.classList.toggle('is-active');
      closeMenus(item);
      if (item.classList.contains('is-active') && focus) {
        const addFocus = () => {
          focus.focus();
          item.removeEventListener('keyup', addFocus);
        };
        item.addEventListener('keyup', addFocus);
      }
	  hideOnClickOutside(nav)
    };

    const openMenu = (item, focusEndOfList = false) => {
      const focusable = [...item.querySelectorAll('a, input')];
      let focus = focusEndOfList ?
        focusable[focusable.length - 1] :
        focusable[0];
      item.classList.add('is-active');
      closeMenus(item);
      if (focus) {
        const addFocus = () => {
          focus.focus();
          item.removeEventListener('keyup', addFocus);
        };
        item.addEventListener('keyup', addFocus);
      }
    };

    const prevItem = item => {
      if (!item.matches(':first-child')) {
        item.previousElementSibling.querySelector('.nav__link').focus();
      } else {
        item
          .closest('.nav__secondary')
          .closest('.nav__item')
          .querySelector('.nav__toggle')
          .focus();
        closeMenus();
      }
    };

    const nextItem = item => {
      if (!item.matches(':last-child')) {
        item.nextElementSibling.querySelector('.nav__link').focus();
      } else {
        item
          .closest('.nav__secondary')
          .closest('.nav__item')
          .querySelector('.nav__toggle')
          .focus();
        closeMenus();
      }
    };

    this.$screen.lg.addEventListener('change', closeMenus);

    navToggles.forEach(t => {
      this.$addEvents(t, toggleEvents, e => {
        if (!this.$screen.lg.matches) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const item = t.closest('.nav__item');
        toggleMenu(item);
      });
      this.$addEvents(t, 'keydown.key[ArrowUp,ArrowDown]', e => {
        if (!this.$screen.lg.matches) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const item = t.closest('.nav__item');
        openMenu(item, e.key === 'ArrowUp');
      });
    });

    navItems.forEach(i => {
      this.$addEvents(i, 'focusout', e => {
        if (!this.$screen.lg.matches) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!i.matches(':focus-within')) closeMenus();
      });
      this.$addEvents(i, 'escape', e => {
        if (!this.$screen.lg.matches) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeMenus();
      });
    });

    navMenus.forEach(m => {
      this.$addEvents(m, 'keydown.key[ArrowUp,ArrowDown]', e => {
        if (!this.$screen.lg.matches) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const item = e.target.closest('.nav__item');
        e.key === 'ArrowDown' ? nextItem(item) : prevItem(item);
      });
    });
	
    const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)
    const hideOnClickOutside = (element) => {
      const outsideClickListener = event => {
        if (!element.contains(event.target) && isVisible(element)) {
          toggleMenu(element)
          removeClickListener();
        }
      }

      const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener)
      }

      document.addEventListener('click', outsideClickListener)
    }
  },
});

new Blue({
  name: 'Header Nav Mobile',
  selector: '.header',
  setup(header) {
    const drawer = header.querySelector('.header__drawer');
    const drawerInner = drawer.querySelector('.drawer__inner');
    const navItems = [...header.querySelectorAll('.nav__primary > .nav__item')];
    const megaItems = header.querySelectorAll(".has-megamenu");
    const utilItems = [...header.querySelectorAll('.util__link')];
    const drawerToggle = header.querySelector('.header__toggle');

    const search = header.querySelector('.search');
    const toggleEvents = 'click.prevent enter.prevent space.prevent';

    const toggleDrawer = () => {
      drawer.classList.toggle('is-active');
      search.classList.remove('is-active');
      drawerToggle.classList.toggle('is-active');
      if (drawer.classList.contains('is-active')) {
        this.$scrollLock.lock(drawerInner);
      } else {
        this.$scrollLock.unlock(drawerInner);
        megaItems.forEach(item => item.classList.remove("is-open"));
      }
    };

    const adjustDrawerSize = () => {
      // grabbing both the full header for most elements and header inner for the megamenu when an alert is present
      const top = [header.offsetHeight, header.querySelector('.header__inner').offsetHeight]
      document.documentElement.style.setProperty('--drawerHeight', `calc(100vh - ${top[0]}px)`);
      document.documentElement.style.setProperty('--headerHeight', `${top[0]}px`);
      document.documentElement.style.setProperty('--headerInnerHeight', `${top[1]}px`);
    };

    megaItems.forEach(item => {
      const link = item.querySelector(".nav__toggle");
      const subMenu = item.querySelector(".mega__columns");
      const menuBack = this.$createElement({
        tag: "button",
        attributes: {
          class: "mega__nav"
        },
        html: `<button class="mega__go-back">Back</button>`
      });
      this.$addEvents([link, menuBack], "click", () =>
        item.classList.toggle("is-open")
      );

      subMenu.insertAdjacentElement("beforebegin", menuBack);
    });

    this.$retach(search, {
      destination: drawerInner,
      mediaQuery: this.$screen.lg_dn,
      movedClass: 'in-drawer',
    });
    utilItems.forEach(i => {
      this.$retach(i, {
        destination: drawerInner,
        mediaQuery: this.$screen.lg_dn,
        movedClass: 'in-drawer',
        wrapper: 'li',
        wrapperClass: 'drawer__item',
      });
    });
    navItems.forEach(i => {
      this.$retach(i, {
        destination: drawerInner,
        mediaQuery: this.$screen.lg_dn,
        movedClass: 'drawer__item',
      });
    });

    // const menuItems = navItems.filter(
    // 	i => !!i.querySelector('.nav__mega')
    // );
    //
    // const relations = [];
    //
    // const toggleMenu = item => {
    // 	if (this.$screen.lg.matches) return;
    // 	item.toggle();
    // };

    // menuItems.forEach(container => {
    // 	const trigger = container.querySelector('.nav__toggle');
    // 	const content = container.querySelector('.nav__mega');
    // 	const config = {
    // 		container,
    // 		trigger,
    // 		content,
    // 		relations,
    // 		externalEvents: true,
    // 		props: ['height', 'opacity'],
    // 	};
    // 	const toggle = new this.$toggle(config);
    // 	relations.push(toggle);
    // 	this.$addEvents(trigger, 'click.prevent', () => toggleMenu(toggle));
    // });


    adjustDrawerSize();
    this.$addEvents(drawerToggle, toggleEvents, toggleDrawer);
    window.addEventListener('resize', adjustDrawerSize);
  },
});

const headerNav = document.querySelector('.header__nav')